import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=144ff821&scoped=true&"
import script from "./Overview.vue?vue&type=script&lang=js&"
export * from "./Overview.vue?vue&type=script&lang=js&"
import style0 from "./Overview.vue?vue&type=style&index=0&id=144ff821&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144ff821",
  null
  
)

export default component.exports